<modal-container #modal [headerTitle]="'password.change'">
  <ng-container class="modal-button-show">
    <btn
      (onEvent)="showChildModal()"
      [classes]="['btn-first-red', 'float-right', 'mr-2']"
      [icon]="'far-lock'"
      [label]="'password.change'"
      [title]="'password.change' | translate"
      data-cy="password-change"
    ></btn>
  </ng-container>
  <ng-container class="modal-body-content">
    <div class="card">
      <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
<!--      <form-row-input-->
<!--        [label]="'password.new'"-->
<!--        [inputType]="'password'"-->
<!--        [icon]="'far-lock'"-->
<!--        [(model)]="plainPass"-->
<!--        data-cy="new-password"-->
<!--      ></form-row-input>-->
<!--      <form-row-input-->
<!--        [label]="'password.repeat'"-->
<!--        [inputType]="'password'"-->
<!--        [icon]="'far-lock'"-->
<!--        [(model)]="plainPass2"-->
<!--        data-cy="repeat-password"-->
<!--      ></form-row-input>-->
      <form-row-password (modelChange)="password = $event" (validityChange)="isValid = $event"></form-row-password>
    </div>
  </ng-container>
  <ng-container class="modal-footer-content">
    <btn
      [label]="'password.change.btn'"
      [title]="'password.change.btn' | translate"
      (onEvent)="changePass()"
      [classes]="['btn', 'btn-first']"
      [icon]="'far-unlock'"
      data-cy="submit"
    ></btn>
  </ng-container>
</modal-container>
